__turbopack_context__.v({
  "notShared": "AccessCell-module__01ShyW__notShared",
  "root": "AccessCell-module__01ShyW__root",
});
